import { useContext } from "react";
import { Link } from "react-router-dom";
import {
    Home, Building2, User, Cable, Package, ChevronDown, Users, BarChart2,
    Smartphone, Crosshair, Globe, MessageSquare, MessagesSquare, GitBranch, Sparkles, Flame, Camera, Megaphone, BookOpen
} from "lucide-react";
import { SidebarContext } from "../../../context/SidebarContext";
import ContainerSubtitles from "./ContainerSubtitles";


export default function SidebarNoMobile() {

    const { location, isOpen, setIsOpen, isEnabledLinks, setIsEnabledLinks, modeTouch, setModeTouch, showText } = useContext(SidebarContext);
    const { leadsOpen, setLeadsOpen } = useContext(SidebarContext);
    const { produtosOpen, setProdutosOpen } = useContext(SidebarContext);
    const { relatoriosOpen, setRelatoriosOpen } = useContext(SidebarContext);
    const { whatsappOpen, setWhatsappOpen } = useContext(SidebarContext);
    const { instagramOpen, setInstagramOpen } = useContext(SidebarContext);
    const { trackingOpen, setTrackingOpen } = useContext(SidebarContext);
    const { adsOpen, setAdsOpen } = useContext(SidebarContext);


    function handleOpenSidebar() {
        setIsOpen(true);
        setIsEnabledLinks(true);
    }

    function handleCloseSidebar() {
        setIsOpen(false);
        setProdutosOpen(false);
        setRelatoriosOpen(false);
        setLeadsOpen(false);
        setTrackingOpen(false);
        setAdsOpen(false);
        setWhatsappOpen(false);
        setInstagramOpen(false);
        setIsEnabledLinks(false);
        setModeTouch(false);
    }

    const isActive = (test) => typeof test === "function" ? test(location.pathname) : location.pathname === test;
    const closeOnClick = () => { if (modeTouch) handleCloseSidebar(); };


    return (
        <aside
            onClick={() => { if (!isOpen) { setModeTouch(true); handleOpenSidebar(); } }}
            onMouseEnter={handleOpenSidebar}
            onMouseLeave={handleCloseSidebar}
            className={`hidden sm:flex flex-col bg-surface-1/85 backdrop-blur-xl text-ink-2 border-r border-white/[0.06] fixed top-0 left-0 h-screen overflow-hidden ${isOpen ? "w-64" : "w-16"} transition-all duration-300 ease-out-expo z-10`}
        >

            {/* === LOGO === */}
            <div className={`h-16 flex items-center flex-shrink-0 border-b border-white/[0.04] ${isOpen ? "px-5 gap-3" : "justify-center"}`}>
                <div className="relative flex-shrink-0">
                    <div className="h-9 w-9 rounded-xl bg-gradient-brand grid place-items-center shadow-glow-sm">
                        <Sparkles className="h-4 w-4 text-white" strokeWidth={2.5} />
                    </div>
                </div>
                {showText && (
                    <span className="font-display font-bold text-lg tracking-tight text-ink-1 animate-fade-in">
                        Metriqa
                    </span>
                )}
            </div>

            {/* === NAV === */}
            <nav className="flex-1 overflow-y-auto overflow-x-hidden py-4 px-2 scrollbar-none">

                <SectionLabel show={showText} label="Diário" />

                <NavLink to="/" icon={Home} label="Dashboard"
                    active={isActive("/")} isOpen={isOpen} showText={showText}
                    enabled={isEnabledLinks} onClick={closeOnClick} />

                <NavLink to="/chat" icon={MessageSquare} label="Chat"
                    active={isActive("/chat")} isOpen={isOpen} showText={showText}
                    enabled={isEnabledLinks} onClick={closeOnClick} />

                <NavLink to="/automacoes" icon={GitBranch} label="Fluxos"
                    active={isActive((p) => p === "/automacoes" || (p.includes("/editar") && !p.startsWith("/agentes")))}
                    isOpen={isOpen} showText={showText}
                    enabled={isEnabledLinks} onClick={closeOnClick} />

                <SectionLabel show={showText} label="WhatsApp" />

                <NavGroup icon={Smartphone} label="WhatsApp"
                    open={whatsappOpen} setOpen={setWhatsappOpen}
                    isOpen={isOpen} showText={showText}
                    active={isActive((p) => p.startsWith("/whatsapp") || p.startsWith("/agentes") || p === "/configuracoes/ia")} />
                {whatsappOpen && isOpen && (
                    <SubMenu>
                        <SubLink to="/whatsapp/chat" label="Chat das sessões" icon={MessagesSquare} active={isActive((p) => p.startsWith("/whatsapp/chat"))} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/whatsapp/campanhas" label="Campanhas" active={isActive((p) => p.startsWith("/whatsapp/campanhas"))} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/whatsapp/fila" label="Fila de Envio" active={isActive("/whatsapp/fila")} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/agentes" label="Agentes" active={isActive((p) => p === "/agentes" || p.startsWith("/agentes/"))} enabled={isEnabledLinks} onClick={closeOnClick} badge="IA" />
                        <SubLink to="/whatsapp/bot-avisos" label="Bot de Avisos" active={isActive("/whatsapp/bot-avisos")} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/whatsapp/respostas-rapidas" label="Respostas rápidas" active={isActive("/whatsapp/respostas-rapidas")} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/whatsapp/sessoes" label="Sessões" active={isActive("/whatsapp/sessoes")} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/whatsapp/oficial" label="Oficial (Meta)" active={isActive("/whatsapp/oficial")} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/whatsapp/relatorios" label="Relatórios" active={isActive("/whatsapp/relatorios")} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/configuracoes/ia" label="Configuração IA" active={isActive("/configuracoes/ia")} enabled={isEnabledLinks} onClick={closeOnClick} />
                    </SubMenu>
                )}

                <SectionLabel show={showText} label="Instagram" />

                <NavGroup icon={Camera} label="Instagram"
                    open={instagramOpen} setOpen={setInstagramOpen}
                    isOpen={isOpen} showText={showText}
                    active={isActive((p) => p.startsWith("/instagram"))} />
                {instagramOpen && isOpen && (
                    <SubMenu>
                        <SubLink to="/instagram/inbox" label="Inbox" active={isActive("/instagram/inbox")} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/instagram/oficial" label="Oficial (Meta)" active={isActive("/instagram/oficial")} enabled={isEnabledLinks} onClick={closeOnClick} />
                    </SubMenu>
                )}

                <SectionLabel show={showText} label="Leads" />

                <NavGroup icon={Users} label="Leads"
                    open={leadsOpen} setOpen={setLeadsOpen}
                    isOpen={isOpen} showText={showText}
                    active={isActive((p) => p === "/leads" || p === "/leads/quentes" || p === "/tags")} />
                {leadsOpen && isOpen && (
                    <SubMenu>
                        <SubLink to="/leads" label="Leads" active={isActive("/leads")} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/leads/quentes" label="Leads Quentes" icon={Flame} active={isActive("/leads/quentes")} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/tags" label="Tags" active={isActive("/tags")} enabled={isEnabledLinks} onClick={closeOnClick} />
                    </SubMenu>
                )}

                <SectionLabel show={showText} label="Análise" />

                <NavGroup icon={BarChart2} label="Relatórios"
                    open={relatoriosOpen} setOpen={setRelatoriosOpen}
                    isOpen={isOpen} showText={showText}
                    active={isActive((p) => ["/relatorios/orderbumps", "/relatorio-grupo", "/vendas", "/relatorio-produtos", "/analise-comparativa"].includes(p))} />
                {relatoriosOpen && isOpen && (
                    <SubMenu>
                        <SubLink to="/relatorios/orderbumps" label="Orderbumps" active={isActive("/relatorios/orderbumps")} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/relatorio-grupo" label="Tráfego" active={isActive("/relatorio-grupo")} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/vendas" label="Vendas" active={isActive("/vendas")} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/relatorio-produtos" label="Produtos" active={isActive("/relatorio-produtos")} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/analise-comparativa" label="Análise IA" active={isActive("/analise-comparativa")} enabled={isEnabledLinks} onClick={closeOnClick} badge="✨" />
                    </SubMenu>
                )}

                <NavGroup icon={Crosshair} label="Tracking"
                    open={trackingOpen} setOpen={setTrackingOpen}
                    isOpen={isOpen} showText={showText}
                    active={isActive((p) => p.startsWith("/tracking"))} />
                {trackingOpen && isOpen && (
                    <SubMenu>
                        <SubLink to="/tracking/funil" label="Funil de Conversão" active={isActive("/tracking/funil")} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/tracking/visitantes" label="Visitantes" active={isActive("/tracking/visitantes")} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/tracking/leads" label="Checkout Leads" active={isActive("/tracking/leads")} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/tracking/videos" label="Vídeos" active={isActive("/tracking/videos")} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/tracking/config" label="Configuração" active={isActive("/tracking/config")} enabled={isEnabledLinks} onClick={closeOnClick} />
                    </SubMenu>
                )}

                <NavGroup icon={Megaphone} label="Tráfego Pago"
                    open={adsOpen} setOpen={setAdsOpen}
                    isOpen={isOpen} showText={showText}
                    active={isActive((p) => p.startsWith("/ads"))} />
                {adsOpen && isOpen && (
                    <SubMenu>
                        <SubLink to="/ads/dashboards" label="Dashboards" active={isActive((p) => p.startsWith("/ads/dashboards"))} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/ads/produto" label="Por produto" active={isActive("/ads/produto")} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/ads/contas" label="Contas de anúncio" active={isActive("/ads/contas")} enabled={isEnabledLinks} onClick={closeOnClick} />
                    </SubMenu>
                )}

                <SectionLabel show={showText} label="Catálogo" />

                <NavGroup icon={Package} label="Produtos"
                    open={produtosOpen} setOpen={setProdutosOpen}
                    isOpen={isOpen} showText={showText}
                    active={isActive((p) => p === "/produtos" || p === "/grupos" || p === "/gastos")} />
                {produtosOpen && isOpen && (
                    <SubMenu>
                        <SubLink to="/produtos" label="Produtos" active={isActive("/produtos")} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/grupos" label="Grupos" active={isActive("/grupos")} enabled={isEnabledLinks} onClick={closeOnClick} />
                        <SubLink to="/gastos" label="Gastos" active={isActive("/gastos")} enabled={isEnabledLinks} onClick={closeOnClick} />
                    </SubMenu>
                )}

                <SectionLabel show={showText} label="Configuração" />

                <NavLink to="/integracoes" icon={Cable} label="Integrações" active={isActive("/integracoes")} isOpen={isOpen} showText={showText} enabled={isEnabledLinks} onClick={closeOnClick} />
                <NavLink to="/dominios" icon={Globe} label="Domínios" active={isActive("/dominios")} isOpen={isOpen} showText={showText} enabled={isEnabledLinks} onClick={closeOnClick} />
                <NavLink to="/empresas" icon={Building2} label="Empresas" active={isActive("/empresas")} isOpen={isOpen} showText={showText} enabled={isEnabledLinks} onClick={closeOnClick} />
                <NavLink to="/usuarios" icon={User} label="Usuários" active={isActive("/usuarios")} isOpen={isOpen} showText={showText} enabled={isEnabledLinks} onClick={closeOnClick} />

                <SectionLabel show={showText} label="Ajuda" />

                <NavLink to="/documentacao" icon={BookOpen} label="Documentação" active={isActive((p) => p.startsWith("/documentacao"))} isOpen={isOpen} showText={showText} enabled={isEnabledLinks} onClick={closeOnClick} />

            </nav>

            <div className="border-t border-white/[0.04] flex-shrink-0">
                <ContainerSubtitles />
            </div>

        </aside>
    );
}


function SectionLabel({ show, label }) {
    if (!show) return <div className="h-4" />;
    return (
        <div className="px-3 mt-5 mb-2 first:mt-0 animate-fade-in">
            <span className="label-overline text-ink-5">{label}</span>
        </div>
    );
}

function NavLink({ to, icon: Icon, label, active, isOpen, showText, enabled, onClick }) {
    const base = "group relative flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all duration-200 ease-out-expo no-tap";
    const inactive = "text-ink-3 hover:bg-white/[0.04] hover:text-ink-1";
    const activeCls = "bg-brand-500/10 text-brand-200 ring-1 ring-brand-500/20 shadow-glow-sm";
    return (
        <Link
            to={enabled ? to : "#"}
            onClick={onClick}
            className={`${base} ${active ? activeCls : inactive} ${!isOpen && "pointer-events-none justify-center"} ${!enabled && "pointer-events-none"}`}
            title={!isOpen ? label : undefined}
        >
            {active && isOpen && (
                <span className="absolute left-0 top-1/2 -translate-y-1/2 h-5 w-0.5 rounded-r-full bg-brand-400 shadow-glow-sm" />
            )}
            <Icon className={`h-5 w-5 flex-shrink-0 ${active ? "text-brand-300" : ""}`} strokeWidth={2} />
            {showText && <span className="text-sm font-medium animate-fade-in">{label}</span>}
        </Link>
    );
}

function NavGroup({ icon: Icon, label, open, setOpen, isOpen, showText, active }) {
    const base = "group relative flex items-center gap-3 px-3 py-2.5 rounded-xl cursor-pointer transition-all duration-200 ease-out-expo no-tap";
    const inactive = "text-ink-3 hover:bg-white/[0.04] hover:text-ink-1";
    const activeCls = "bg-brand-500/10 text-brand-200 ring-1 ring-brand-500/20";
    return (
        <div
            onClick={() => isOpen && setOpen(!open)}
            className={`${base} ${active ? activeCls : inactive} ${!isOpen && "pointer-events-none justify-center"}`}
            title={!isOpen ? label : undefined}
        >
            {active && isOpen && (
                <span className="absolute left-0 top-1/2 -translate-y-1/2 h-5 w-0.5 rounded-r-full bg-brand-400 shadow-glow-sm" />
            )}
            <Icon className={`h-5 w-5 flex-shrink-0 ${active ? "text-brand-300" : ""}`} strokeWidth={2} />
            {showText && (
                <>
                    <span className="text-sm font-medium animate-fade-in">{label}</span>
                    <ChevronDown className={`ml-auto h-4 w-4 text-ink-4 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
                </>
            )}
        </div>
    );
}

function SubMenu({ children }) {
    return (
        <div className="ml-5 mt-1 mb-2 pl-3 border-l border-white/[0.06] flex flex-col gap-0.5 animate-fade-in">
            {children}
        </div>
    );
}

function SubLink({ to, label, active, enabled, onClick, badge, icon: Icon }) {
    return (
        <Link
            to={enabled ? to : "#"}
            onClick={onClick}
            className={`flex items-center gap-2 px-3 py-2 rounded-lg text-xs transition-colors duration-150 no-tap ${
                active
                    ? "bg-brand-500/8 text-brand-200"
                    : "text-ink-4 hover:text-ink-2 hover:bg-white/[0.03]"
            } ${!enabled && "pointer-events-none"}`}
        >
            {Icon && <Icon className="h-3.5 w-3.5 flex-shrink-0" strokeWidth={2.2} />}
            <span className="font-medium">{label}</span>
            {badge && (
                <span className="ml-auto chip-brand !py-0 !px-1.5 !text-[10px]">{badge}</span>
            )}
        </Link>
    );
}
